export enum BeneficiaryTypeEnum {
  Primary = 1,
  Alternate = 2,
  Specified = 3
}
